import Lightbox from './Lightbox';

export default Lightbox;
